var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(typeof _vm.plots === 'object')?_c('apexchart',{attrs:{"width":"100%","type":"scatter","options":_vm.plots.options,"series":_vm.plots.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }